import { Button } from '@crowdfpl/ui-web/button';
import { Dialog, DialogContent } from '@crowdfpl/ui-web/dialog';
import { ExternalLink } from 'lucide-react';
import { trackUmamiEvent } from '@/helpers/analytics';
import { XIcon } from './XIcon';

interface XFollowModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function XFollowModal({ open, onOpenChange }: XFollowModalProps) {
  const handleFollow = () => {
    trackUmamiEvent('follow_x_modal_follow_click');
    window.open('https://x.com/CrowdFPL', '_blank', 'noopener,noreferrer');
    onOpenChange(false);
  };

  const handleMaybeLater = () => {
    trackUmamiEvent('follow_x_modal_maybe_later_click');
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[calc(100vw-2rem)] sm:w-full sm:max-w-md bg-background border-border rounded-2xl p-8">
        <div className="flex flex-col items-center text-center space-y-6">
          {/* Icon */}
          <div className="h-14 w-14 rounded-full bg-foreground/10 flex items-center justify-center">
            <XIcon className="h-7 w-7 text-foreground" />
          </div>

          {/* Title */}
          <h2 className="text-xl font-bold text-foreground">Stay with the Crowd</h2>

          {/* Body text */}
          <div className="space-y-2">
            <p className="text-sm text-foreground">Nice to have you with us.</p>
            <p className="text-sm text-foreground">
              Follow top-rated managers, CrowdFPL updates, and the best FPL duels on our X.
            </p>
          </div>

          {/* Buttons */}
          <div className="w-full space-y-3 pt-2">
            <Button
              onClick={handleFollow}
              className="w-full h-11 bg-brand-x-green hover:bg-brand-x-green/90 text-white shadow-sm"
            >
              <ExternalLink className="h-3.5 w-3.5 mr-2" />
              Follow CrowdFPL on X
            </Button>
            <button
              type="button"
              onClick={handleMaybeLater}
              className="w-full text-xs text-muted-foreground hover:underline"
            >
              Maybe later
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
